import { EventBus } from '@/store/eventBus';

export default function emitSelectedImage(state, payload) {
    const data = {
        selectedImageId: state.selectedImage,
        selectedImagePath: state.selectedImageSrc
    };
    EventBus.$emit(`${payload.namespace}-selected`, data);
}
